<template>
  <div class="flex flex-col space-y-6 sm:flex-row sm:space-y-0 sm:space-x-6">
    <i v-html="$icons.check_circle" class="text-ontick-green-600"></i>
    <div class="space-y-12">
      <div class="space-y-4">
        <h2 class="text-2xl font-bold sm:text-4xl">
          Transação realizada com sucesso!
        </h2>
        <p class="text-sm text-gray-500 dark:text-gray-400">
          Você já pode começar a usar os benefícios
          {{ productByType.subtitleVariation }}
          <span class="font-bold text-ontick-carbon-900 dark:text-gray-300">{{
            productByType.subtitleName
          }}</span
          >. Bons investimentos!
        </p>
      </div>
      <div class="space-y-6">
        <div class="flex items-center space-x-4">
          <div class="flex items-center space-x-2">
            <p class="whitespace-nowrap text-lg font-bold sm:text-2xl">
              {{ productByType.infoType }}
              <span v-if="product.type === 'EXTENSION'">{{
                product.name
              }}</span>
            </p>
            <ontick-plan-logo-component
              :plan="product.name.split(' ')[0]"
              v-if="product.type === 'PLAN'"
            />
          </div>
          <div class="h-[2px] w-full bg-ontick-steel-500"></div>
        </div>
        <div class="flex flex-col space-y-4">
          <dl>
            <dt>ID da transação</dt>
            <dd>#{{ product.id }}</dd>
          </dl>
          <dl>
            <dt>Desenvolvedor</dt>
            <dd>
              {{ product.developer }}
            </dd>
          </dl>
          <dl>
            <dt>Preço</dt>
            <dd>
              {{ product.price | currency }}
            </dd>
          </dl>
          <dl>
            <dt>Recorrência</dt>
            <dd>
              {{ product.days === 30 ? "Mensal" : "Anual" }}
            </dd>
          </dl>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ontickPlanLogoComponent from "../../../../shared/components/basic/ontick-plan-logo.component.vue";

export default {
  components: {
    ontickPlanLogoComponent,
  },

  props: {
    product: {
      type: Object,
    },
  },

  computed: {
    productByType() {
      const types = {
        PLAN: {
          subtitleVariation: `do seu plano`,
          subtitleName: `OnTick ${
            this.product.name.charAt(0).toUpperCase() +
            this.product.name.slice(1).toLowerCase().split(" ")[0]
          }`,
          infoType: "Plano OnTick",
        },
        EXTENSION: {
          subtitleVariation: "da sua extensão",
          subtitleName: this.product.name,
          infoType: "Extensão",
        },
      };
      return types[this.product.type];
    },
  },
};
</script>

<style lang="scss" scoped>
dl {
  dt {
    @apply text-sm;
  }
  dd {
    @apply text-xl  font-bold text-ontick-carbon-900 dark:text-gray-300;
  }
}
</style>
